import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'month', label: 'Month' },
  { key: 'headcount_start', label: 'Headcount (Start)', align: 'right' },
  { key: 'headcount_end', label: 'Headcount (End)', align: 'right' },
  { key: 'separations', label: 'Separations', align: 'right' },
  { key: 'turnover_rate', label: 'Turnover Rate', align: 'right', type: 'percent' },
];

export function TurnoverReport() {
  return (
    <ReportView
      title="Turnover / Attrition"
      description="Headcount and finalized separations by month, with the resulting turnover rate (separations ÷ average headcount). Defaults to the trailing 12 months."
      endpoint="/reports/hr/turnover"
      columns={COLUMNS}
      filters={['dateRange']}
      xlsx
    />
  );
}
